import { render, staticRenderFns } from "./to-top.vue?vue&type=template&id=7c491960&"
import script from "./to-top.vue?vue&type=script&lang=js&"
export * from "./to-top.vue?vue&type=script&lang=js&"
import style0 from "./to-top.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c491960')) {
      api.createRecord('7c491960', component.options)
    } else {
      api.reload('7c491960', component.options)
    }
    module.hot.accept("./to-top.vue?vue&type=template&id=7c491960&", function () {
      api.rerender('7c491960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/to-top/to-top.vue"
export default component.exports